// Constants
import {
  FETCH_FERTILIZERS,
  ADD_FERTILIZER,
} from './constants'

export function fetchFertilizers (payload) {
  return {
    type: FETCH_FERTILIZERS,
    payload,
  }
}

export function addFertilizer (payload) {
  return {
    type: ADD_FERTILIZER,
    payload,
  }
}
